module.exports = __webpack_public_path__ + "img/00_logo_text.709e988a.svg";